import { faCirclePlus } from "@fortawesome/pro-solid-svg-icons"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { IOrderList } from "order/model"
import { openCreateOrderPopup } from "order/tools/form"
import { UnexpectedErrorPage } from "page/components/UnexpectedErrorPage"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { LinearLoader } from "ui/components/LinearLoader"
import { PageHeader } from "ui/components/main-layout/PageHeader"
import { canAccessDspDeal, canSaveOrder } from "user/tools/permissions"
import { OrderList } from "./OrderList"

interface IOrdersPageProps {
  isLoading: boolean
  hasLoadingError: boolean
  list: IOrderList
}

const OrdersPageFn = React.memo(({ isLoading, hasLoadingError, list }: IOrdersPageProps): JSX.Element => {
  if (hasLoadingError) {
    return <UnexpectedErrorPage />
  }
  return (
    <FlexBox vertical fullWidth fullHeight ai="start" jc="start" sx={{ animation: "fadeIn 600ms" }}>
      <PageHeader
        title={translate("order.page.title")}
        actionButtons={
          canSaveOrder()
            ? [
                {
                  id: "add-order",
                  label: translate("button.add"),
                  icon: faCirclePlus,
                  onClick: () => openCreateOrderPopup()
                }
              ]
            : undefined
        }
      />
      <FlexBox
        fullWidth
        jc="start"
        ai="start"
        vertical
        sx={{
          overflow: "auto",
          p: "1rem",
          pt: 0
        }}>
        {isLoading ? (
          <LinearLoader text={translate("label.loading.data")} sx={{ mt: "2rem" }} />
        ) : (
          <>
            <Typography
              sx={{
                fontSize: "1.2rem",
                fontWeight: 500,
                mt: "1.5rem",
                mb: "1rem",
                color: theme => theme.palette.text.primary2
              }}>
              {translate("order.my.title")}
            </Typography>
            <OrderList isLoading={isLoading} list={list} isDspDeal={canAccessDspDeal()} />
          </>
        )}
      </FlexBox>
    </FlexBox>
  )
})

export const OrdersPage = connect(
  (state: IRootState): IOrdersPageProps => ({
    isLoading: state.app.isInitializating,
    hasLoadingError: state.app.hasInitError,
    list: state.order.list
  })
)(OrdersPageFn)
